import { useRouteMeta } from '@/plugins/useRouteMeta'
import { useNotificationStore } from '@/stores/notification'
import type { RouteLocation } from 'vue-router'

/**
 * Shows notifications only on certain routes.
 * Ie, Don't show the level up notification on game play pages.
 *
 * @param {RouteLocation} to
 */
export default function showNotification(to: RouteLocation) {
  const routeMeta = useRouteMeta()

  if (!routeMeta.isGamePlayRoute(to.name as string)) {
    const notificationStore = useNotificationStore()

    notificationStore.showNotification()
  }
}
